import produce from 'immer';
import * as immer from 'immer';
import { constants } from '../actions/constants/fichaContactologica.constants';
import { dataFichaContactologia } from '../../modules/pacientes/fichaContactologica/contactologiaBaseData';

immer.setAutoFreeze(false);

const initialState = {
  graduaciones: [],
  fichaContactologica: dataFichaContactologia,
  error: null,
};

export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case constants.GET_GRADUACIONES_CONTACT_SUCCESS: {
      return {
        ...draft,
        graduaciones: payload,
      };
    }
    case constants.GET_GRADUACIONES_CONTACT_FAILURE: {
      return {
        ...draft,
        graduaciones: [],
        error: payload.toString(),
      };
    }
    case constants.GET_GRADUACION_CONTACTOLOGICA_SUCCESS: {
      return {
        ...draft,
        fichaContactologica: payload,
      };
    }
    case constants.GET_GRADUACION_CONTACTOLOGICA_FAILURE: {
      return {
        ...draft,
        fichaContactologica: dataFichaContactologia,
        error: payload.toString(),
      };
    }
    case constants.GET_GRADUACION_ULTIMA_OPTOMETRIA_SUCCESS: {
      return {
        ...draft,
        fichaContactologica: { ...dataFichaContactologia, graduacion_optometrica_asociada: payload },
      };
    }
    case constants.GET_GRADUACION_ULTIMA_OPTOMETRIA_FAILURE: {
      return {
        ...draft,
        fichaContactologica: dataFichaContactologia,
        error: payload.toString(),
      };
    }

    case constants.GUARDAR_GRADUACION_CONTACTOLOGICA_REQUEST: {
      return {
        ...draft,
        fichaContactologica: payload,
      };
    }

    default:
      return draft;
  }
});
